/** Pull a user-facing message out of an unknown error. The SDK
 *  attaches a parsed body to ApiError instances; prefer
 *  ``body.detail`` (FastAPI/HTTPException) then ``body.error``
 *  (legacy V1 shape) before falling back to ``Error.message``. */
export function humaniseError(err: unknown): string {
  if (err instanceof Error) {
    const body = (err as Error & { body?: { detail?: string; error?: string } }).body;
    if (body?.detail) return String(body.detail);
    if (body?.error) return String(body.error);
    return err.message;
  }
  return "Something went wrong.";
}
